// The two words the panel uses for the two people CC supports: the «Usuario» who
// receives parcels and the «Mensajero» who delivers them. Spelled once because two screens must say
// exactly the same thing — the audience selector of an «Entrega»'s actions and the account-type
// strip of the ficha — and two copies drift the first time somebody edits only one. It lives in the
// app's `lib/` and not in either slice, so neither slice has to import the other. TODO: i18n
export const USER_COURIER_LABEL = {
  user: 'Usuario',
  courier: 'Mensajero',
} as const satisfies Record<'user' | 'courier', string>;
